import { createFileRoute } from '@tanstack/react-router'
import { customersQuery, productsQuery } from '../../../data/service.ts'
import { AccountManagement } from '../../../features/serviceManagement/accounts/AccountManagement.tsx'
import { queryClient } from '../../../query-client.ts'

export const Route = createFileRoute('/_app/smp/accounts')({
	beforeLoad: async () => {
		const [customers, products] = await Promise.all([
			queryClient.ensureQueryData(customersQuery),
			queryClient.ensureQueryData(productsQuery),
		])
		return { customers, products }
	},
	component: AccountManagement,
})
